import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LayoutModule } from '@angular/cdk/layout';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { BigInputActionComponent } from '@app/shared/big-input/big-input-action.component';
import { BigInputComponent } from '@app/shared/big-input/big-input.component';
import { InspektTableComponent } from '@app/shared/inspekt-table/inspekt-table.component';
import { MatDualListComponent } from '@app/shared/mat-dual-list/mat-dual-list.component';
import { FormPageTemplateComponent } from '@app/shared/components/form-page-template/form-page-template.component';
import { FormInputComponent } from '@app/shared/components/form-input/form-input.component';
import { FormSelectComponent } from '@app/shared/components/form-select/form-select.component';
import { FormTextAreaComponent } from '@app/shared/components/form-text-area/form-text-area.component';
import { FormCheckBoxComponent } from '@app/shared/components/form-check-box/form-check-box.component';

import { TranslateModule } from '@ngx-translate/core';
import { FormInputWithCopyComponent } from '@app/shared/components/form-input-with-copy/form-input-with-copy.component';
import { DynamicFormComponent } from '@app/shared/components/dynamic-form/dynamic-form.component';
import { DynamicFormFieldComponent } from '@app/shared/components/dynamic-form-control/dynamic-form-control.component';
import { FormControlService } from '@app/shared/services/form-control.service';
import { FormSchemaEditorComponent } from '@app/shared/components/form-schema-editor/form-schema-editor.component';

import { PreviewPanelComponent } from '@app/shared/components/preview-panel/preview-panel.component';
import { SchemaFormModule } from 'ngx-schema-form';
import { WidgetMenuComponent } from '@app/shared/components/widget-menu/widget-menu.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { SnackBarComponent } from '@app/shared/snack-bar/snack-bar.component';
import { RequiredPermissionDirective } from '@app/core/directives/required-permission.directive';
import { MaterialButtonComponent } from '@app/shared/components/material-button/material-button.component';

import { AceModule } from 'ngx-ace-wrapper';
import { ACE_CONFIG } from 'ngx-ace-wrapper';
import { AceConfigInterface } from 'ngx-ace-wrapper';

const DEFAULT_ACE_CONFIG: AceConfigInterface = {
  showPrintMargin: false,
  wrap: true
};

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        CdkTableModule,
        MatAutocompleteModule,
        MatBadgeModule,
        MatGridListModule,
        MatNativeDateModule,
        MatTableModule,
        MatSortModule,
        MatButtonModule,
        MatToolbarModule,
        MatSelectModule,
        MatTabsModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatChipsModule,
        MatCardModule,
        MatSidenavModule,
        MatCheckboxModule,
        MatSlideToggleModule,
        MatListModule,
        MatMenuModule,
        MatIconModule,
        MatTooltipModule,
        MatExpansionModule,
        NgxDatatableModule,
        MatDialogModule,
        TranslateModule,

        SchemaFormModule,
        BigInputComponent,
        BigInputActionComponent,
        InspektTableComponent,
        InspektTableComponent,
        MatDualListComponent,
        FormPageTemplateComponent,
        FormInputComponent,
        FormSelectComponent,
        FormTextAreaComponent,
        FormCheckBoxComponent,
        FormInputWithCopyComponent,
        DynamicFormComponent,
        DynamicFormFieldComponent,
        FormSchemaEditorComponent,
        PreviewPanelComponent,
        WidgetMenuComponent,
        SnackBarComponent,
        RequiredPermissionDirective,
        MaterialButtonComponent,
        AceModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        CdkTableModule,
        MatAutocompleteModule,
        MatBadgeModule,
        MatGridListModule,
        MatNativeDateModule,
        MatTableModule,
        MatSortModule,
        MatButtonModule,
        MatToolbarModule,
        MatSelectModule,
        MatTabsModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatChipsModule,
        MatCardModule,
        MatSidenavModule,
        MatCheckboxModule,
        MatSlideToggleModule,
        MatListModule,
        MatMenuModule,
        MatIconModule,
        MatTooltipModule,
        LayoutModule,
        MatExpansionModule,
        BigInputComponent,
        BigInputActionComponent,
        InspektTableComponent,
        NgxDatatableModule,
        MatDualListComponent,
        FormPageTemplateComponent,
        FormInputComponent,
        FormSelectComponent,
        FormTextAreaComponent,
        FormCheckBoxComponent,
        FormInputWithCopyComponent,
        TranslateModule,
        DynamicFormComponent,
        DynamicFormFieldComponent,
        FormSchemaEditorComponent,
        PreviewPanelComponent,
        WidgetMenuComponent,
        TranslateModule,
        SchemaFormModule,
        RequiredPermissionDirective,
        MaterialButtonComponent
    ],
    providers: [
        FormControlService,
        {
            provide: ACE_CONFIG,
            useValue: DEFAULT_ACE_CONFIG
        }
    ]
})
export class SharedModule {
}
